import React from 'react';
import { useTranslation } from 'react-i18next';
import { en, fr } from './i18n';
import classnames from 'classnames';

export interface OnAirButtonsProps {
  className?: string;
}

const OnAirButtons = ({ className = '' }: OnAirButtonsProps) => {
  const { i18n, t } = useTranslation('prp-filter-panel');
  i18n.addResourceBundle('en', 'prp-filter-panel', en, true, true);
  i18n.addResourceBundle('fr', 'prp-filter-panel', fr, true, true);

  const onAirButtons = [
    {
      id: 'on-air-today',
      label: t('onAirToday'),
      dimensionId: tscConfig.AliasDimensionOnAirToday,
      trackingId: '&ic=PG_BTN_OnAirProducts_Today'
    },
    {
      id: 'on-air-yesterday',
      label: t('onAirYesterday'),
      dimensionId: tscConfig.AliasDimensionOnAirYesterday,
      trackingId: '&ic=PG_BTN_OnAirProducts_Yesterday'

    },
    {
      id: 'on-air-recently',
      label: t('onAirRecently'),
      dimensionId: tscConfig.AliasDimensionOnAirRecently,
      trackingId: '&ic=PG_BTN_OnAirProducts_Recently'
    },
  ];

  const onAirName = 'on-air-radio-buttons';

  return (
    <ul className={classnames("prp-filter-panel__blocks prp-fiter-panel__on-air", className)}>
      {onAirButtons.map((btn) => (
        <li key={btn.id} className="prp-filter-panel__on-air__item">
          <input
            type="radio"
            id={btn.id}
            name={onAirName}
            className="prp-filter-panel__on-air__item__input"
            checked={window.location.search.includes(btn.dimensionId)}
                  onChange={() => {
                      window.location.href = `/pages/productresults?dimensions=${btn.dimensionId}&page=1&pageSize=36&rd=false${btn.trackingId}`;
            }}
            value={btn.dimensionId}
          />
          <label htmlFor={btn.id} className="prp-filter-panel__on-air__item__label">{btn.label}</label>
        </li>
      ))}
    </ul>
  );
}

export default OnAirButtons;
